import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

// Hero icon names enum
export const HeroIconNames = {
  // Destinations
  STOCKHOLM: 'stockholm',
  OSLO: 'oslo',
  HELSINKI: 'helsinki',
  GOTHENBURG: 'gothenburg',
  COPENHAGEN: 'copenhagen',
  BERGEN: 'bergen',

  // Experiences
  HOTEL: 'hotel',
  SPA: 'spa',
  GYM: 'gym',
  RESTAURANT: 'restaurant',
  MEETING: 'meeting',
  POOL: 'pool',

  // Member Benefits
  EXTRA_POINTS_APP: 'extra-points-app',
  EARLY_ACCESS: 'early-access',
  COFFEE: 'coffee',
  WATER: 'water',
  DISCOUNT: 'discount',
  RESTAURANT_VOUCHER: 'restaurant-voucher',
  LATE_CHECKOUT: 'late-checkout',
  SPA_FOR_TWO: 'spa-for-two',
  STRAWBERRY_MASTERCARD: 'strawberry-mastercard',
  EARLY_CHECKIN: 'early-checkin',
  EARN_POINTS: 'earn-points',
  CHOOSE_ROOM: 'choose-room',
  FREE_CANCELLATION: 'free-cancellation',
  GUARANTEED_ROOM: 'guaranteed-room',
  UPGRADE: 'upgrade',
  BONUS_NIGHT: 'bonus-night',
  STRAWBERRY_WEBSITE: 'strawberry-website',
  EXTRA_POINTS: 'extra-points',

  // Values
  PEOPLE: 'people',
  PLANET: 'planet',
  PROFIT: 'profit',
};

// Mapping from enum values to actual file names
const iconMapping = {
  [HeroIconNames.STOCKHOLM]: '648195f1e6485f763a57f041_Strawberry_HeroIcon_Stockholm_64px 1.svg',
  [HeroIconNames.OSLO]: '6481cc118e41f40e203dd1cb_Strawberry_HeroIcon_Oslo_64px 1.svg',
  [HeroIconNames.HELSINKI]: '6481cc10bc7996f2d7c8adb2_Strawberry_HeroIcon_Helsinki_64px 1.svg',
  [HeroIconNames.GOTHENBURG]: '6481cc1142437e3bb5729548_Strawberry_HeroIcon_Gothenburg_64px 1.svg',
  [HeroIconNames.COPENHAGEN]: '6481cc11b3cce6fad92048ae_Strawberry_HeroIcon_Copenhagen_64px 1.svg',
  [HeroIconNames.BERGEN]: '6481cc11bc7996f2d7c8add6_Strawberry_HeroIcon_Bergen_64px 1.svg',
  
  [HeroIconNames.HOTEL]: '6481cc10a9f41af6934fcc48_Strawberry_HeroIcon_Hotel_64px 1.svg',
  [HeroIconNames.SPA]: '6481cc101ed92e6c47635678_Strawberry_HeroIcon_Spa_64px 1.svg',
  [HeroIconNames.GYM]: '6481cc10b4d3aba53a2d0b54_Strawberry_HeroIcon_Gym_64px 1.svg',
  [HeroIconNames.RESTAURANT]: '6481cc105c7d7eb7729d1e98_Strawberry_HeroIcon_Restaurant_64px 1.svg',
  [HeroIconNames.MEETING]: '6481cc106de998b2e95e4641_Strawberry_HeroIcon_Meeting_64px 1.svg',
  [HeroIconNames.POOL]: '6481cc10c8e2ed22344987a3_Strawberry_HeroIcon_Pool_64px 1.svg',
  
  [HeroIconNames.EXTRA_POINTS_APP]: '6481cc1002aa60dbb2d6847e_Strawberry_HeroIcon_Extrapoang_i_app_64px 1.svg',
  [HeroIconNames.EARLY_ACCESS]: '6481cc0f72022b5f8765b44e_Strawberry_HeroIcon_Valj_Rum_64px 1.svg',
  [HeroIconNames.COFFEE]: '6481cc0f468140038c320e71_Strawberry_HeroIcon_Kaffe_64px 1.svg',
  [HeroIconNames.WATER]: '6481cc0f8b4dcf6bfee440df_Strawberry_HeroIcon_Mineralvatten_64px 1.svg',
  [HeroIconNames.DISCOUNT]: '6481cc0f72022b5f8765b44e_Strawberry_HeroIcon_Valj_Rum_64px 1.svg',
  [HeroIconNames.RESTAURANT_VOUCHER]: '6481cc0f324e32f8eb3b730d_Strawberry_HeroIcon_Restaurangkupong_64px 1.svg',
  [HeroIconNames.LATE_CHECKOUT]: '6481cc0f7918993e0b3f2fbc_Strawberry_HeroIcon_Sen_utcheckning_64px 1.svg',
  [HeroIconNames.SPA_FOR_TWO]: '6481cc0fcf1982531bb3ce94_Strawberry_HeroIcon_Spa2_64px 1.svg',
  [HeroIconNames.STRAWBERRY_MASTERCARD]: '6481cc0f8b4dcf6bfee44092_Strawberry_HeroIcon_Strawberry_mastercard_64px 1.svg',
  [HeroIconNames.EARLY_CHECKIN]: '6481cc0f1e583cd05d7fd2bb_Strawberry_HeroIcon_Tidig_Incheckning_64px 1.svg',
  [HeroIconNames.EARN_POINTS]: '6481cc0f387f691d7bde6cb4_Strawberry_HeroIcon_Tjana_Poang_64px 1.svg',
  [HeroIconNames.CHOOSE_ROOM]: '6481cc0f9183c6fd9be0dc2c_Strawberry_HeroIcon_Valj_Rum_64px 2.svg',
  [HeroIconNames.FREE_CANCELLATION]: '6481cc0fc8e2ed22344986e5_Strawberry_HeroIcon_Free_Cancelation_64px 1.svg',
  [HeroIconNames.GUARANTEED_ROOM]: '6481cc12f9ae7ae6e2646d2c_Strawberry_HeroIcon_Guaranteed_Room_64px 1.svg',
  [HeroIconNames.UPGRADE]: '6481cc0f98ae215303976f1c_Strawberry_HeroIcon_Upgrade_64px 1.svg',
  [HeroIconNames.BONUS_NIGHT]: '6481cc10387f691d7bde6d3b_Strawberry_HeroIcon_Bonusnatt_64px 1.svg',
  [HeroIconNames.STRAWBERRY_WEBSITE]: '6481cc10b4d3aba53a2d0abc_Strawberry_HeroIcon_Choice.se_64px 1.svg',
  [HeroIconNames.EXTRA_POINTS]: '6481cc1002aa60dbb2d684a3_Strawberry_HeroIcon_Extrapoaang_64px 1.svg',
  
  [HeroIconNames.PEOPLE]: '6481cc10c8e2ed223449877a_Strawberry_HeroIcon_People_64px 1.svg',
  [HeroIconNames.PLANET]: '6481cc101e583cd05d7fd3d4_Strawberry_HeroIcon_Planet_64px 1.svg',
  [HeroIconNames.PROFIT]: '6481cc104da2f4ff3dca0510_Strawberry_HeroIcon_Profit_64px 1.svg',
};

const HeroIcon = ({ name, size = 64, color = 'currentColor', className = '' }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  
  const iconFileName = iconMapping[name];
  if (!iconFileName) {
    console.warn(`Hero icon "${name}" not found`);
    return null;
  }

  // If color is currentColor, use the theme's text color
  const effectiveColor = color === 'currentColor' 
    ? isDarkMode ? '#FFFFFF' : theme.palette.text.primary
    : color;

  // Fix the path to work in both development and production
  const iconPath = `/assets/hero-icons/${iconFileName}`;

  return (
    <img
      src={iconPath}
      alt={name}
      style={{
        width: size,
        height: size,
        filter: `brightness(0) saturate(100%) ${effectiveColor === '#FFFFFF' ? '' : `invert(1) ${getColorFilter(effectiveColor)}`}`,
        opacity: isDarkMode ? 1 : 0.87, // Slightly reduce opacity in light mode for better contrast
        transition: 'filter 0.2s ease, opacity 0.2s ease', // Smooth transition for color changes
      }}
      className={className}
    />
  );
};

// Helper function to generate color filter
const getColorFilter = (color) => {
  const rgb = hexToRgb(color);
  if (!rgb) return '';

  // Convert RGB to HSL
  const hsl = rgbToHsl(rgb.r, rgb.g, rgb.b);
  
  return `
    sepia(${Math.round(hsl.s * 100)}%) 
    saturate(${Math.round((hsl.s + 0.2) * 400)}%) 
    hue-rotate(${Math.round(hsl.h)}deg) 
    brightness(${Math.round(hsl.l * 100)}%)
  `.trim();
};

// Helper function to convert hex to RGB
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

// Helper function to convert RGB to HSL
const rgbToHsl = (r, g, b) => {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: h = 0;
    }
    h /= 6;
  }

  return { h: h * 360, s, l };
};

HeroIcon.propTypes = {
  name: PropTypes.oneOf(Object.values(HeroIconNames)).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default HeroIcon; 